import React, {useCallback, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {shopStore} from 'app/store/global';
import {getLinkPath} from 'app/utils/link_helper';
import PointsExchangeCard from 'app/components/shop/exchange/PointsExchangeCard';

const PointsExchange = observer((): React.ReactElement => {
    const points = shopStore.data.user.points || '0';

    useEffect(() => {
        shopStore.setShopUrl(null);
    }, []);

    const handleClick = useCallback(() => {
        shopStore.setSkipScrollToTop(true);
    }, []);

    return <div className="shop-exchange">
        <h1 className="visually-hidden-title">
            {`${I18n.t('menu_links.shop')} - ${I18n.t('money_header')}`}
        </h1>
        <PointsExchangeCard points={points} />
        <p className="shop-exchange__hint">
            <Link
                to={getLinkPath('/faq/points')}
                onClick={handleClick}
            >
                {I18n.t('shop.exchange.points_awarded_link')}
            </Link>
            {I18n.t('shop.exchange.points_awarded_hint')}
        </p>
    </div>;
});

export default PointsExchange;
